/**
 * permissions.js — 全局权限定义
 *
 * 每个 key 对应一个可控页面/功能。
 * Admin 账号始终拥有全部权限（不受此列表限制）。
 * Staff/其他角色账号根据 permissions 数组决定可访问哪些页面。
 */

export const ALL_PERMISSIONS = [
  // ── Inventory ──────────────────────────────────────────────────
  // Note: "Inventory Ledger" removed — page hidden, covered by Records Center
  { key: "stock_lookup",        label: "Stock Lookup",        group: "Inventory" },
  { key: "analytics",           label: "Analytics",           group: "Inventory" },
  { key: "purchase_orders",     label: "Purchase Orders",     group: "Inventory" },
  { key: "receiving",           label: "Receiving",           group: "Inventory" },
  { key: "sku_master",          label: "SKU Master",          group: "Inventory" },

  // ── Sales & Orders ─────────────────────────────────────────────
  { key: "sales_orders",        label: "Sales Orders",        group: "Sales & Orders" },
  { key: "pending_orders",      label: "Pending Orders",      group: "Sales & Orders" },
  // Note: "Out Records" removed — page hidden, covered by Records Center
  { key: "customers",           label: "Customers",           group: "Sales & Orders" },

  // ── Warehouse ──────────────────────────────────────────────────
  { key: "assembly_schedule",   label: "Assembly Schedule",   group: "Warehouse" },
  { key: "assembly_board",      label: "Assembly Board",      group: "Warehouse" },
  { key: "operations_centre",   label: "Operations Centre",   group: "Warehouse" },
  { key: "location_mgmt",       label: "Location Management", group: "Warehouse" },
  // Note: "Picking History" (web) removed — page hidden, covered by Records Center
  { key: "picking_prekey",      label: "Pre-key Draft",       group: "Warehouse" },
  { key: "delivery_note",       label: "Delivery Note",       group: "Warehouse" },
  { key: "delivery_planner",    label: "Delivery Planner",    group: "Warehouse" },
  { key: "records_center",      label: "Records Center",      group: "Warehouse" },
  { key: "shortages",           label: "Shortages",           group: "Warehouse" },

  // ── Mobile App ─────────────────────────────────────────────────
  { key: "mobile_picking",      label: "Picking",             group: "Mobile App" },
  { key: "mobile_quickpull",    label: "Quick Pull",          group: "Mobile App" },
  { key: "mobile_outbound",     label: "Outbound",            group: "Mobile App" },
  { key: "mobile_history",      label: "Picking History",     group: "Mobile App" },
  { key: "mobile_find",         label: "Find Cabinet",        group: "Mobile App" },
  { key: "mobile_move",         label: "Move Cabinet",        group: "Mobile App" },
  { key: "mobile_addstock",     label: "Stock Adjustment",    group: "Mobile App" },
  { key: "mobile_return",       label: "Return Stock",        group: "Mobile App" },
  { key: "mobile_stocktake",    label: "Stocktake",           group: "Mobile App" },
];

/** 按 group 分组，返回 { groupName: [permDef, ...] } */
export function groupedPermissions() {
  return ALL_PERMISSIONS.reduce((acc, p) => {
    if (!acc[p.group]) acc[p.group] = [];
    acc[p.group].push(p);
    return acc;
  }, {});
}

/**
 * 判断用户是否有某权限。
 * Admin 始终返回 true。
 * @param {object} user  — { role, permissions: string[] }
 * @param {string} perm  — 权限 key
 */
export function hasPerm(user, perm) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return Array.isArray(user.permissions) && user.permissions.includes(perm);
}
